module.exports = __webpack_public_path__ + "img/gita.e1e30819.jpg";